import React from "react";
import { Route, Routes } from "react-router-dom";
import AllProductPage from "../pages/SuperAdmin/AllProducts/index";
import CarProducts from "../pages/SuperAdmin/CarProducts/index";
import LandProducts from "../pages/SuperAdmin/LandProducts/index";
import Bin from "pages/SuperAdmin/Bin";
import CustomerList from "pages/SuperAdmin/Customer";
import Users from "pages/SuperAdmin/Users";
import Company from "pages/SuperAdmin/Company";
import PackageManage from "pages/SuperAdmin/PackageManage";
import Permissions from "pages/SuperAdmin/Permissions";
import HistoryLog from "pages/SuperAdmin/HistoryLog";
import Bill from "pages/SuperAdmin/Bill";
import Detail from "pages/SuperAdmin/Company/pages/Detail";
import BillDebt from "pages/SuperAdmin/Company/pages/BillDebtForm";
import Dashboard from "pages/SuperAdmin/Dashboard";
import UnderConstruction from "components/UnderConstruction";
const SuperAdminRoute = () => {
  return (
    <Routes>
      <Route path="super_admin" element={<Dashboard />} />
      <Route path="all-products-pawn" element={<AllProductPage />} />
      <Route path="all-products-cars" element={<CarProducts />} />
      <Route path="all-products-lands" element={<LandProducts />} />
      <Route path="customer-list" element={<CustomerList />} />
      <Route path="bin" element={<Bin />} />
      <Route path="users" element={<Users />} />
      <Route path="company" element={<Company />} />
      <Route
        path="company/detail/:company_id/:package_id"
        element={<Detail />}
      />
      <Route path="package-management" element={<PackageManage />} />
      <Route path="permissions" element={<Permissions />} />
      <Route path="history-log" element={<HistoryLog />} />
      <Route path="bill" element={<Bill />} />
      <Route path="company/create-invoice/:company_id" element={<BillDebt />} />

      {/* path ที่กำลังปรับปรุงแก้ไข */}
      {["import_data_pawn", "import_information_pawn","import_information_buy_pawn"].map((path) => (<Route path={path} element={<UnderConstruction />} />))}
    </Routes>
  );
};

export default SuperAdminRoute;
